const initialState = {
  vendors: [],
  loading: false,
  error: null,
};

const vendorReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_VENDORS':
      return {
        ...state,
        vendors: [...state.vendors, action.payload],
      }
    case 'SET_VENDORS':
      return {
        ...state,
        vendors: action.payload,
      };
    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default vendorReducer;
